module.exports = __webpack_public_path__ + "23f4469f46ce6efe583c7ea399199afb.pdf";